var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "30px",
    viewBox: "0 0 21 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "placeholder") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Avenu---Visual-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6.0-Contact",
    transform: "translate(-710.000000, -1052.000000)",
    fill: "#50AFA8",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "placeholder",
    transform: "translate(710.000000, 1052.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0046399,3.07127953 C13.7795939,-1.02375984 6.92892415,-1.02375984 2.70328294,3.07127953 C-1.10390135,6.76131501 -0.360440875,13.5721828 1.6985101,17.8844989 C3.75746107,22.196815 8.34849875,30 10.3539614,30 C12.3594241,30 16.2070013,22.9523436 19.0094127,17.8844989 C21.8118242,12.8166542 21.8118242,6.76131501 18.0046399,3.07127953 Z M10.4593197,13.8459985 C8.4866792,13.8459985 6.88785228,12.2963682 6.88785228,10.3844268 C6.88785228,8.47248531 8.4866792,6.92285503 10.4593197,6.92285503 C12.4319602,6.92285503 14.0307871,8.47248531 14.0307871,10.3844268 C14.0307871,12.2963682 12.4319602,13.8459985 10.4593197,13.8459985 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.12c59b8b55c0a811a107e14d23e2bd70.svg";
export { ForwardRef as ReactComponent };